import styled from 'styled-components'

const Strong = styled.strong<{ secondary?: boolean }>`
  color: ${({ theme, secondary }) =>
    `rgb(${secondary ? theme.secondaryColor : theme.mainColor})`};
  font-family: var(--font-sans-serif);
  background: ${({ theme, secondary }) =>
    `rgb(${secondary ? theme.secondaryColor : theme.mainColor}, 0.2)`};
  padding: 0 0.25em;
`

export const texts = [
  {
    dates: [],
    range: [new Date('2024-01-15'), new Date('2024-06-08')],
    pathRange: [new Date('2024-01-01'), new Date('2024-02-20')],
    title: <>Primaires et Caucus</>,
    text: (
      <>
        <p>
          Dans chaque État, les électrices et électeurs choisissent leur
          candidat préféré lors d’élections appelées{' '}
          <Strong secondary>«primaires»</Strong> (pour la plupart des États) ou{' '}
          <Strong secondary>«caucus»</Strong> (pour quelques États).
        </p>
        <p>
          Ces élections sont indirectes: on ne vote pas directement pour son
          candidat démocrate ou républicain favori, mais pour des délégués qui
          sont affiliés au candidat choisi et qui iront le représenter lors des
          conventions nationales.
        </p>
      </>
    ),
    articles: [
      [
        880318268548,
        'Les trois leçons de la victoire de Trump en Caroline du Sud',
      ],
      [
        365299699732,
        'Victoire éclair pour Trump à la primaire républicaine de l’Iowa',
      ],
      [
        832056914413,
        'Donald Trump remporte la primaire républicaine du New Hampshire',
      ],
    ],
  },
  {
    dates: [new Date('2024-03-05')],
    range: [],
    pathRange: [new Date('2024-02-20'), new Date('2024-06-08')],
    title: <>Super Tuesday</>,
    text: (
      <>
        <p>
          Lors du <Strong secondary>Super Tuesday</Strong>, le 5 mars 2024,
          seize États dévoilent les résultats des caucus et des primaires, dont
          la Floride et la Californie.
        </p>
        <p>
          On connaît en général dès cette étape le nom des deux adversaires
          finaux.
        </p>
        <p>
          Selon les sondages, Donald Trump devrait ce jour-là triompher de Nikki
          Haley, sa seule concurrente restante, et rester seul en lice.
        </p>
      </>
    ),
    articles: [],
  },
  {
    dates: [
    ],
    range: [new Date('2024-07-15'), new Date('2024-08-22')],
    pathRange: [new Date('2024-06-08'), new Date('2024-09-01')],
    title: <>Conventions nationales</>,
    text: (
      <>
        <p>
          Chaque parti politique organise une immense réunion appelée
          <Strong secondary>«convention nationale»</Strong>, où il officialise
          son candidat à la présidence.
        </p>
        <p>
          Celle du Parti républicain s'est tenue à Milwaukee, dans le Wisconsin,
          du 15 au 18 juillet, alors que la convention démocrate se déroulera du
          19 au 22 août à Chicago, dans l’Illinois.
        </p>
        <p>
          Les délégués de chaque État y participent. Ils élisent le candidat
          officiel du parti. Celui qui reçoit la majorité des votes des délégués
          gagne.
        </p>
        <p>
          Le candidat qui remporte l’élection choisit à ce moment son ou sa
          futur(e) vice-président(e).
        </p>
      </>
    ),
    articles: [],
  },
  {
    dates: [
      new Date('2024-06-27'),
      new Date('2024-09-10'),
      new Date('2024-10-01'),
    ],
    range: [], //[new Date('2024-09-16'), new Date('2024-10-09')],
    pathRange: [new Date('2024-09-01'), new Date('2024-10-20')],
    title: <>Premier débat présidentiel</>,
    text: (
      <>
        <p>
        Place aux <Strong>débats télévisés</Strong>. Biden a débattu face à Trump le 27 juin, avant de se retirer de la course le 21 juillet. Le 10 septembre, Harris et Trump se sont affrontés lors du 2ème débat.
        </p>
        <p>
        Les candidats à la vice-présidence, Walz et Vance, ont eu leur débat le 1<sup>er</sup> octobre.
        </p>
      </>
    ),
    articles: [],
  },
  {
    dates: [new Date('2024-11-05')],
    range: [],
    pathRange: [new Date('2024-10-20'), new Date('2024-11-25')],
    title: <>Élection présidentielle</>,
    text: (
      <>
        <p>
          Lors de l'<Strong>élection présidentielle</Strong>, les bulletins de
          vote portent les noms des candidats à la présidence et à la
          vice-présidence. On connaît dès la nuit même (ou le lendemain, selon
          où l’on se trouve) le nom du gagnant.{' '}
        </p>
        <p>
          Le processus électoral est simple en apparence, mais il s’agit d’une
          élection par suffrage indirect. Le candidat qui remporte l’élection
          dans un État remporte l’ensemble des «grands électeurs» de son État
          (aussi appelé collège électoral). Leur nombre est déterminé par la
          population de l’État.{' '}
        </p>
        <p>
          Pour gagner l’élection, un candidat doit comptabiliser une majorité
          absolue des grands électeurs (270 voix, soit la moitié plus un des 538
          grands électeurs) pour remporter l’élection.{' '}
        </p>
        <p>
          Il est donc possible qu’un candidat remporte une majorité de voix (si
          on compte tous les votes du pays) mais perde l’élection car il n’a pas
          assez de grands électeurs. C’est ce qui est arrivé avec Hillary
          Clinton et Donald Trump en 2016.{' '}
        </p>
      </>
    ),
    articles: [],
  },
  {
    dates: [],
    range: [new Date('2024-12-11'), new Date('2025-01-06')],
    pathRange: [new Date('2024-11-25'), new Date('2025-01-06')],
    title: <>Vote du collège électoral</>,
    text: (
      <>
        <p>
          Les grands électeurs de chaque État votent en fonction des résultats
          de l’élection dans leur État. le{' '}
          <Strong secondary>vote du collège électoral</Strong> est en fait une formalité,
          puisqu’on connaît déjà le vainqueur de l’élection.
        </p>
      </>
    ),
    articles: [],
  },
  {
    dates: [new Date('2025-01-20')],
    range: [],
    pathRange: [new Date('2025-01-06'), new Date('2025-01-31')],
    title: <>Inauguration day</>,
    text: (
      <>
        <p>
          Lors de l'<Strong>Inauguration day</Strong>, le président élu prête serment, puis prononce le discours
          d’investiture. Son entrée en fonction débute à midi, heure de
          Washington.
        </p>
      </>
    ),
    articles: [],
  },
]
